import React from "react";
import { Box } from "@mui/material";
import { Pause } from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import AudioRecorder from "../audioInput";

export function ChatSendControls({
  loading,
  onSendClick,
  onPauseClick,
  StyledSendButton,
  messageSetter,
  isRecording,
  setIsRecording,
  handleRecord,
  transcriptionLanguage = "mr",
  compact = false,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: compact ? 0.5 : 1,
        flexShrink: 0,
      }}
    >
      <AudioRecorder
        setInputValue={messageSetter}
        setIsRecording={setIsRecording}
        isRecording={isRecording}
        handleRecord={handleRecord}
        transcriptionLanguage={transcriptionLanguage}
      />
      {!loading && (
        <StyledSendButton onClick={onSendClick} aria-label="Send message">
          <SendIcon />
        </StyledSendButton>
      )}
      {loading && (
        <StyledSendButton onClick={onPauseClick} aria-label="Pause message">
          <Pause />
        </StyledSendButton>
      )}
    </Box>
  );
}
